export class OrderOwner {
	advertiserId: string | undefined;
	advertiserName: string | undefined;
	otherPayerId: string | undefined;
	otherPayerName: string | undefined;
}
